// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"235":"cf2a0f0e1f06be49fd23","372":"01053a3abafd54459eac","858":"04a9203d288d4f8adccc","980":"7087d9d5b1f3f18d05d5"}[chunkId] + ".js";
};